<template>
    <div>
        <div v-show="revieweeFeedback.length === 0">
            <l-no-data :text="$t(`profile.feedback.empty`)" icon="/img/icons/feedback.png" />
        </div>

        <div class="row">
            <div v-for="feedback in revieweeFeedback" :key="feedback._id" class="col-md-12">
                <div
                    class="mouseover-parent clickable"
                    style="margin-bottom: 35px;"
                    tabindex="0"
                    @click="showFeedbackModal({ id: feedback._id })"
                    @keyup.enter="showFeedbackModal({ id: feedback._id })"
                >
                    <l-feedback-list-item :feedback="feedback" />
                </div>
            </div>
        </div>

        <!-- MODAL -->
        <l-modal v-show="showModal" size="m" :close-on-backdrop-click="false" @close="goBack">
            <template #header>
                <i
                    v-if="showPrivateNoteLock"
                    class="fal fa-lock r-default-margin-s"
                    data-test-id="lock-private-note"
                ></i>
                {{ modalTitle }}
            </template>
            <template #body>
                <router-view @close="goBack" @title="updateModalTitle"></router-view>
            </template>
        </l-modal>
        <!--/MODAL -->
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import LModal from "@/components/LModal";
import LNoData from "@/components/LNoData";

import LFeedbackListItem from "@/components/LFeedbackListItem";

export default {
    components: {
        LModal,
        LNoData,

        LFeedbackListItem,
    },
    props: {
        revieweeFeedback: {
            type: Array,
            required: true,
        },
        reviewCycle: {
            type: Object,
            required: true,
        },
        revieweeId: {
            type: String,
            required: true,
        },
        role: {
            type: String,
            required: true,
        },
        contributorId: {
            type: String,
            required: true,
        },
        viewAs: {
            type: String,
            required: true,
        },
        view: {
            type: String,
            required: true,
        },
        entrypoint: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            showModal: false,
            modalTitle: "",
            showPrivateNoteLock: false,
        };
    },
    computed: {
        ...mapGetters({
            getFeedbackDetails: "feedback/feedback/details",
        }),
    },
    watch: {
        $route: {
            immediate: true,
            handler(newRoute) {
                this.showModal = newRoute.meta && newRoute.meta.modal;

                if (newRoute.name === "ReviewsUpdateFeedbackDetails") {
                    const feedback = this.getFeedbackDetails(newRoute.params.id);

                    this.modalTitle = feedback?.title ?? "Feedback";
                }
            },
        },
    },
    methods: {
        showFeedbackModal({ id }) {
            this.$router.push(`${this.$route.path}/feedback/details/${id}`);
        },
        updateModalTitle(title, showPrivateNoteLock) {
            this.modalTitle = title;
            this.showPrivateNoteLock = showPrivateNoteLock;
        },
        goBack() {
            this.$router.push(
                `/reviews/update/${this.reviewCycle._id}/reviewee/${this.revieweeId}/${this.role}/${this.contributorId}/viewAs/${this.viewAs}/${this.view}/${this.entrypoint}`,
            );
        },
    },
};
</script>
